import { ScreenStatus } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import { StyledQuestionControls } from './QuestionControls.styled';
import TimeLeft from 'src/components/studentPages/StudentRealTimeActivity/activityTypes/StudentSortImagesActivity/QuestionControls/TimeLeft/TimeLeft';
import Button from '@/shared/Button/Button';
import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import { useContext } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';

export default function QuestionControls({ state, actions }) {
  const globalContext = useContext(GlobalContext);

  const playPauseButton = (
    <Button
      shape="circle"
      type="primary"
      icon={
        ScreenStatus.isPlaying(state.currentScreen.status) ? (
          <PauseOutlined />
        ) : (
          <CaretRightOutlined />
        )
      }
      onClick={actions.togglePaused}
    />
  );

  return state.currentScreen ? (
    <StyledQuestionControls>
      <div className="screen">
        {state.currentScreen.index + 1} / {state.screens?.length}
      </div>
      <div className="timer">
        {ScreenStatus.isAudio(state.currentScreen.status)
          ? playPauseButton
          : null}
        {ScreenStatus.isActivity(state.currentScreen.status) ? (
          <>
            <span className="seconds-left">
              <TimeLeft secondsLeft={state.secondsLeft} />
            </span>
            {playPauseButton}
          </>
        ) : null}
        {ScreenStatus.isResults(state.currentScreen.status) ? (
          <Button type="primary" onClick={actions.skipStep}>
            Continuar
          </Button>
        ) : null}
      </div>

      <div className="buttons">
        {ScreenStatus.isAudio(state.currentScreen.status) &&
        globalContext.state.user?.teacher ? (
          <Button onClick={actions.skipStep}>Skip</Button>
        ) : null}
      </div>
    </StyledQuestionControls>
  ) : null;
}
